module.exports = __webpack_public_path__ + "img/dislike1.d305092a.png";